import { Injectable, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../ui/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog) { }

  openDialog(data: any, width: string = '350px') {
    return this.dialog.open(DialogComponent, {
      width: width,
      data: data
    });
  }

  openDialogGenerique<T>(component: Type<T>, data: any, width: string = '350px') {
    return this.dialog.open(component, {
      width: width,
      data: data
    });
  }
}

export interface DialogData {
  title: string;
  content: string;
}
